import { generateSpanWithDataTestId } from '@app/shared/utils';

export const numericValidator = async (_: unknown, value: string) => {
  if (value && !/^\d+$/.test(value)) {
    return Promise.reject(
      generateSpanWithDataTestId('Поле должно содержать только числа', 'alert')
    );
  }
  return Promise.resolve();
};
